import styled from 'styled-components';

export const VersionFooter = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  font-size: 12px;
`;
